import { useState } from "react";
import { useTranslation } from "react-i18next";

import { validateCustomerForm } from "../../utils/validators";
import { scrollToTop } from "../../utils/functions";
import CustomerForm from "../customer/Form";
import CustomerType from "../CustomerType";
import ButtonNext from "../ButtonNext";

const Step2 = ({
  customerData,
  setCustomerData,
  onComplete
}) => {
  const { t } = useTranslation();

  const [invalidFields, setInvalidFields] = useState({});

  const handleTypeChange = (value) => {
    setInvalidFields({});
    setCustomerData((prevData) => ({
      ...prevData,
      type: value,
      isDriver: value !== "company"
    }));
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    scrollToTop();

    const { isValid, invalidFields } = validateCustomerForm(t, customerData);
    setInvalidFields(invalidFields);
    isValid && onComplete();
  };

  return (
    <form className="step step--2" onSubmit={handleNextStep}>
      <h2 className="step__title">{t("step2.title")}</h2>

      {!customerData.type && (
        <>
          <p className="step__subtitle">{t("step2.subtitle")}</p>
          <CustomerType onChange={handleTypeChange} />
        </>
      )}
      {customerData.type && (
        <>
          <CustomerForm
            formData={customerData}
            setFormData={setCustomerData}
            invalidFields={invalidFields}
            setInvalidFields={setInvalidFields}
          />
          <ButtonNext />
        </>
      )}
    </form>
  );
};

export default Step2;
